import React from 'react';
import RoadmapTimeline from './components/RoadmapTimeline';

export default function ProductManagerRoadmapDisplay({ roadmap, maxMonth, isUnlocked, roleKey }) {
  return (
    <RoadmapTimeline
      roadmap={roadmap}
      title={`Your ${roadmap?.totalMonths || 6}-Month Product Manager Career Roadmap`}
      subtitle="Product & Delivery Journey"
      maxMonth={maxMonth}
      isUnlocked={isUnlocked}
      fileName="tekyu-product-manager-roadmap.pdf"
      roleKey={roleKey || "productmanager"}
    />
  );
}

